<template>
  <v-container grid-list-md>
    <v-layout row wrap align-center justify-center fill-height>
      <v-flex xs12 sm8 lg4 md5>
        <v-card class="login-card">
          <v-card-title>
            <span class="headline">Login to CommunityClick</span>
          </v-card-title>

          <v-spacer />

          <v-card-text>
            <v-layout
              row
              fill-height
              justify-center
              align-center
              v-if="loading"
            >
              <v-progress-circular :size="50" color="primary" indeterminate />
            </v-layout>

            <v-form v-else ref="form" v-model="valid" lazy-validation>
              <v-container>
                <v-text-field
                  v-model="credentials.username"
                  :counter="70"
                  label="Email address"
                  :rules="rules.email"
                  maxlength="70"
                  required></v-text-field>
                <v-text-field
                  type="password"
                  v-model="credentials.password"
                  :counter="20"
                  label="Password"
                  :rules="rules.password"
                  maxlength="20"
                  required></v-text-field>
              </v-container>
              <v-btn class="white--text" type="submit" color="#2c485b":disabled="!valid" @click="login"
                >Login</v-btn
              >
              <!--<v-btn class="white&#45;&#45;text" color="#2c485b" @click="register">Register</v-btn>-->
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */

import axios from "axios";
import swal from "sweetalert2";
import router from "../../router";

export default {
  name: "Auth",
  data: () => ({
    credentials: {},
    valid: true,
    loading: false,
    rules: {
      username: [
        v => !!v || "Username is required",
        v =>
          (v && v.length > 3) || "A username must be more than three characters"
        // v => /\^[a-z0-9_]+\$.test(v) || "A username can only contains letters and digits"
      ],
      password: [v => !!v || "Password is required"]
    }
  }),
  methods: {
    login: function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        axios
          .post(this.api_url+'/auth/', this.credentials)
          .then(res => {
            this.$session.start()
            this.$session.set('user', JSON.stringify(res.data))
            router.push('/')
          })
          .catch(e => {
            this.loading = false
            if (e.response.status === 400) {
              swal.fire({
                type: 'error',
                title: 'Error',
                text: 'Wrong username or password',
                showConfirmButton: false,
                showCloseButton: false,
                timer: 3000
              })
            }
          })
      }
    },
    register() {
      router.push("/register");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Auth.vue